import { Injectable } from '@angular/core';
import axios from 'src/app/Service/axios';
import { ReportContext, ReportDefinition } from '../../report.models';
import { StopTankerApiResult, StopTankerCredentials, StopTankerReportRow } from './stop-tanker-report.models';

@Injectable({ providedIn: 'root' })
export class StopTankerReportApiService {
  async loadReport(
    definition: ReportDefinition,
    context: ReportContext,
    credentials: StopTankerCredentials,
  ): Promise<StopTankerApiResult> {
    const response = definition.stopTankerMode === 'stop'
      ? await axios.post(`${definition.endpoint}?vstrSDate=${context.startDate}&vstrUnitID=${context.id}&vstrEDate=${context.startDate}&strSTime=${context.startTime}&strETime=${context.endTime}&iSystemUser=${credentials.iSystemUser}&strSession=${encodeURIComponent(credentials.strSession)}`)
      : await axios.post(definition.endpoint!, {
        ...credentials,
        strUnitID: context.id,
        strSDate: context.startDate,
        strEDate: context.endDate,
      });
    const data: unknown = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
    if (Array.isArray(data)) return data as StopTankerReportRow[];
    if (data && typeof data === 'object') return data as StopTankerApiResult;
    throw new Error('پاسخ گزارش نامعتبر است');
  }
}
